import React, { useCallback } from "react";
import { Card } from "react-bootstrap";
import { FileWithPath } from "react-dropzone";
import { v4 as uuidv4 } from "uuid";

import DropBox from "../../../dropzone/DropBox";
import FileGrid from "../../../dropzone/FileGrid";
// import "../../../dropzone/DropBox.styles.css";

import {
  useAppDispatch,
  useAppSelector,
} from "../../../../redux/hooks/redux-hooks";
import {
  setDocument,
  removeDocument,
} from "../../../../redux/actions/BidCreationDocumentsActions";

const BidCreationDocumentSection = () => {
  const dispatch = useAppDispatch();
  const files = useAppSelector((state) => state.bidCreationDocs.documents)!;

  const onDrop = useCallback(
    (acceptedFiles: FileWithPath[]) => {
      acceptedFiles.forEach((file) => {
        dispatch(
          setDocument({
            id: uuidv4(),
            file: file,
          })
        );
      });
    },
    [dispatch]
  );

  const handleFileRemove = (id: string) => {
    dispatch(removeDocument(id));
  };

  return (
    <>
      <Card
        style={{
          border: "none",
          height: "100%",
        }}
      >
        <DropBox accept={{ "application/pdf": [".pdf"] }} onDrop={onDrop} />
        <FileGrid files={files} onClick={handleFileRemove} />
      </Card>
    </>
  );
};

export default BidCreationDocumentSection;
